import React, {useContext} from 'react';
import './SettingsFooter.less';
import {FooterCaption} from "elements/footer-caption/FooterCaption";
import {FooterLink} from "compositions/footer-link/FooterLink";
import {FooterButton} from "compositions/footer-button/FooterButton";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const SettingsFooter = ({isShowLogout, onLogoutClick, termsUrl, version, onVersionClick}) => {
	const translations = useContext(TranslationsContext);

	return <div className="settings-footer">
		<div className="settings-footer__logout" style={{visibility: isShowLogout ? 'visible' : 'hidden'}}>
			<FooterButton
				text={getSafeTranslation('SettingsFooter.logOutCaption', translations)}
				onClick={onLogoutClick}
			/>
		</div>
		<div className="settings-footer__terms">
			<FooterLink
				url={termsUrl}
				text={getSafeTranslation('SettingsFooter.termsConditionsCaption', translations)}
			/>
		</div>
		<div className="settings-footer__version" onClick={onVersionClick}>
			<FooterCaption text={version}/>
		</div>
	</div>
}
